export const API_BASE_URL = "https://api.smilekuafor.com";

// --- UYGULAMA VE MARKA AYARLARI ---
export const BUSINESS_NAME = "RandevUpp";
export const COMPANY_NAME = "Vireliosoft";

export const COMPANY_MOTTO = "Test";



export const COMPANY_MOTTO_HEADER = "MOTTO";

export const FASTBOOKING_TEXT_TOP = "MUSTERI ISMI";

export const FASTBOOKING_TEXT_TOP_UNDER = "2.0"

export const FASTBOOKING_TEXT_GENERAL_1 = "Tarzınızı Keşfedin"

export const FASTBOOKING_FOOTER = "Musteri Falan Filan"